module.exports = __webpack_public_path__ + "static/media/loan.9fc12607.svg";